var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokes2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 132,
    viewBox: "0 0 161 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M104.081 93.3105L117.597 93.926L117.136 104.056L103.62 103.441L104.081 93.3105Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M56.0762 38.7051L65.5601 37.6999L66.5653 47.1839L57.0813 48.189L56.0762 38.7051Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M95.3257 53.1309L102.349 55.0128L100.467 62.0362L93.4438 60.1543L95.3257 53.1309Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.5728 103.113L40.7719 110.997L34.7786 115.71L28.5795 107.826L34.5728 103.113Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M78.5985 26.638C82.205 27.6044 85.912 25.4642 86.8783 21.8577C87.8447 18.2512 85.7044 14.5442 82.098 13.5779C78.4915 12.6115 74.7845 14.7517 73.8181 18.3582C72.8518 21.9647 74.992 25.6717 78.5985 26.638Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M83.9692 144.72C87.2388 145.596 90.5996 143.655 91.4757 140.386C92.3517 137.116 90.4114 133.755 87.1418 132.879C83.8722 132.003 80.5115 133.944 79.6354 137.213C78.7593 140.483 80.6996 143.843 83.9692 144.72Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M100.929 29.5322C101.924 32.0966 101.058 35.2582 98.9071 36.97C98.3957 37.3714 97.8271 37.6997 97.1982 37.858C96.3 38.0885 95.3539 37.9599 94.4322 37.8476C90.959 37.4265 86.9242 37.4509 84.6073 40.07C82.3204 42.649 82.8255 46.8992 85.0291 49.547",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.4618 10.1211C47.2418 10.728 44.932 11.455 43.3029 13.0855C41.6829 14.7184 41.0293 17.5525 42.4813 19.3452C44.4984 21.8276 48.6177 20.6625 51.4417 22.1787C53.8371 23.4647 54.8151 26.5244 54.45 29.2146",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M111.078 114.809C108.056 117.979 106.404 122.421 106.599 126.789C106.7 128.922 107.304 131.189 108.957 132.555C111.294 134.489 115.024 133.844 117.248 131.787C118.477 130.645 119.308 128.551 118.113 127.375C117.238 126.516 115.786 126.694 114.646 127.148C111.172 128.524 108.617 131.993 108.35 135.719C108.082 139.445 110.09 143.251 113.33 145.119C114.671 145.892 116.183 146.345 117.713 146.63C121.694 147.38 125.892 146.995 129.683 145.55",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M114.219 59.6473C114.067 58.7797 114.009 57.9182 114.04 57.0515C114.103 55.4532 114.515 53.8428 115.603 52.6154C116.692 51.3881 118.558 50.6288 120.418 50.9732",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M118.497 25.7501C118.281 30.2877 114.775 34.4726 110.346 35.468",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M138.79 76.4921C142.903 74.9719 145.598 72.0081 144.808 69.8722C144.019 67.7362 140.044 67.2371 135.931 68.7572C131.818 70.2774 129.124 73.2413 129.913 75.3772C130.703 77.5131 134.677 78.0123 138.79 76.4921Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M115.68 69.397L103.391 76.4774L111.787 83.9282L115.68 69.397Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M40.5601 55.7891L39.6294 65.7208L52.7258 60.9044L40.5601 55.7891Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M84.5238 104.717C84.5238 104.717 83.976 114.117 86.5223 118.212C86.5223 118.212 88.4351 115.917 92.0796 116.596C95.7265 117.265 90.2259 103.063 90.2259 103.063L84.5238 104.717Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M130.739 98.3487C133.225 98.7555 135.72 99.4912 137.798 100.923C139.875 102.354 141.514 104.562 141.855 107.057",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M10.3651 85.7582C12.1869 88.4672 15.6065 89.6622 18.8574 89.9084C25.1994 90.3868 31.7108 87.7571 35.9313 82.9851",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M52.3736 118.459C48.3595 123.68 45.573 129.846 44.3108 136.315",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M44.7324 92.2197C44.7443 90.704 45.3006 89.2379 46.0481 87.9192C46.171 87.7118 46.2963 87.4954 46.51 87.3796C46.8577 87.1939 47.2901 87.3386 47.6428 87.5293C49.4625 88.4879 50.6962 90.2702 51.6044 92.1191C52.0466 93.0163 52.4271 93.9643 52.5432 94.9664C52.7053 96.4423 52.2357 97.9797 51.2707 99.1055C51.1467 99.2453 51.0113 99.3917 50.8258 99.4382C50.611 99.4864 50.3964 99.3904 50.2111 99.2927C47.6297 97.9473 44.6999 95.3548 44.7324 92.2197Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M57.0137 82.3555L63.9018 72.3171L73.6339 78.995L66.7458 89.0334L57.0137 82.3555Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M86.5653 79.5742C89.389 80.3308 92.2915 78.6551 93.0481 75.8313C93.8047 73.0076 92.129 70.1051 89.3052 69.3485C86.4815 68.5919 83.579 70.2676 82.8224 73.0914C82.0658 75.9151 83.7415 78.8176 86.5653 79.5742Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M86.5669 79.5762L86.3265 89.9813",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M61.4342 108.654C62.697 109.646 64.1041 110.494 65.6638 110.845C67.2234 111.196 68.9614 110.988 70.248 110.026C72.3059 108.481 74.7781 102.52 70.869 102.039C67.6948 101.65 63.0891 106.425 61.4342 108.654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M63.0633 57.3454C66.4622 60.8423 69.8521 64.3368 73.2486 67.8426C72.6086 63.3064 72.5603 58.6788 73.1053 54.1332",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokes2);
export default __webpack_public_path__ + "static/media/strokes-2.79fb5427a9eae694742a36516460f5f5.svg";
export { ForwardRef as ReactComponent };